/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/form-field/custom-elements';

import { defineCustomElement as defineOsdsFormField } from '@ovhcloud/ods-stencil/components/form-field/custom-elements/osds-form-field.js';


export const OsdsFormField = /*@__PURE__*/ defineContainer<JSX.OsdsFormField>('osds-form-field', defineOsdsFormField, [
  'error',
  'flex'
]);

